import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MoneyService } from '../../services/money/money.service';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'money',
})
export class MoneyPipe implements PipeTransform {
  constructor(private _moneyService: MoneyService) {}

  /**
   * Format a value to money
   *
   * @param value {string | number} - should be in subunits
   * @param currencyCode {string} - Currency code
   * @param locale {string} - i
   */
  transform(
    value: any,
    currencyCode = 'USD',
    locale = 'en_US'
  ): string | Observable<string> {
    if (value instanceof Observable) {
      if (currencyCode && locale) {
        return value.pipe(
          map((v) => this.formatInSuperUnit(v, currencyCode, locale))
        );
      } else {
        return of('');
      }
    } else {
      if (currencyCode && locale) {
        return this.formatInSuperUnit(value, currencyCode, locale);
      } else {
        return '';
      }
    }
  }

  formatInSuperUnit(value: any, currencyCode: string, locale: string): string {
    const superUnit = this._moneyService.subToSuperUnit(value, currencyCode);

    return this._moneyService.format(superUnit, currencyCode, locale);
  }
}
